// Compiles the user-added inlet Aux columns (Aux 4+) into a readable note for
// custiteminlet_connection_notes. The built-in Aux 1-3 (and Main/Pilot) map to
// structured item fields; the extra Aux connections have no structured fields,
// so their values across the inlet tables overflow here.

import type { AnswerState } from "../types";

// Inlet tables (qCode) → label, in display order.
const INLET_TABLES: Array<[string, string]> = [
  ["SIZE_TABLE", "Size"],
  ["ORIENTATION_TABLE", "Orientation"],
  ["UP", "UP"],
  ["MATCH_OFFSET_POSITION", "Position"],
  ["INLET_INSERT", "Insert"],
  ["IN", "IN"],
  ["ORIGIN", "Origin"],
  ["PANEL", "Panel"],
];

function isBlank(v: unknown): boolean {
  if (v == null) return true;
  const s = String(v).trim();
  return s === "" || s.toLowerCase() === "none";
}

export function buildInletConnectionNotes(answers: AnswerState, extraAux: number): string {
  if (extraAux <= 0) return "";
  const lines: string[] = [];
  for (let n = 4; n <= 3 + extraAux; n++) {
    const parts: string[] = [];
    for (const [code, label] of INLET_TABLES) {
      const v = answers[`${code}/AUX_${n}_1`];
      if (isBlank(v)) continue;
      parts.push(`${label}=${String(v).trim()}`);
    }
    if (parts.length) lines.push(`Aux ${n}: ${parts.join(", ")}`);
  }
  return lines.join("\n");
}
